import { Component, OnInit } from '@angular/core';
declare var $: any;


@Component({
  selector: 'app-vision-mission',
  templateUrl: './vision-mission.component.html',
  styleUrls: ['./vision-mission.component.scss']
})
export class VisionMissionComponent implements OnInit {
constructor() {}

  ngOnInit(): void {
    this.showCard(1);
  }

  showCard(id: number) {
    const cards = {
      1: { element: '#who', button: '#who-btn' },
      2: { element: '#founder', button: '#founder-btn' },
      3: { element: '#inspiration', button: '#inspiration-btn' },
    };

    Object.keys(cards).forEach((key) => {
      if (key === id.toString()) {
        $(cards[key].element).collapse('show');
        $(cards[key].button).addClass('active');
      } else {
        $(cards[key].element).collapse('hide');
        $(cards[key].button).removeClass('active');
      }
    });
  }
}
